import { useState, useCallback } from "react";

export const useStationFilters = (stations, placedStations) => {
  const [nameFilter, setNameFilter] = useState("");
  const [placementFilter, setPlacementFilter] = useState("all");
  const [categoryFilter, setCategoryFilter] = useState("all");

  const isStationPlaced = useCallback(
    (station) => {
      if (!station?.id) return false;
      return placedStations.some((s) => s.id === station.id);
    },
    [placedStations]
  );

  const getUniqueCategories = useCallback(() => {
    const categories = new Set();
    stations.forEach((station) => {
      if (station.category) {
        categories.add(station.category);
      }
    });
    return Array.from(categories).sort();
  }, [stations]);

  const filteredStations = useCallback(() => {
    return stations.filter((station) => {
      const isPlaced = isStationPlaced(station);

      if (nameFilter) {
        const name = (station.name || "").toLowerCase();
        const filterLower = nameFilter.toLowerCase();
        if (!name.includes(filterLower)) {
          return false;
        }
      }

      if (placementFilter === "placed" && !isPlaced) {
        return false;
      }
      if (placementFilter === "unplaced" && isPlaced) {
        return false;
      }

      if (categoryFilter !== "all" && station.category !== categoryFilter) {
        return false;
      }

      return true;
    });
  }, [
    stations,
    nameFilter,
    placementFilter,
    categoryFilter,
    isStationPlaced,
  ]);

  return {
    nameFilter,
    setNameFilter,
    placementFilter,
    setPlacementFilter,
    categoryFilter,
    setCategoryFilter,
    filteredStations,
    getUniqueCategories,
    isStationPlaced,
  };
};

